// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.me-page-title {
	display: block;
	font-size: 0.65rem;
	font-weight: 700;
	letter-spacing: 0.1em;
	color: #111827;
	text-transform: uppercase;
	margin-bottom: 0.25rem;
}

.me-section-icon {
	font-size: 0.65rem;
	color: #9ca3af;
}

/* ── Show card header (mirrors wf-show-header in the workflow) ── */
.me-show-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 0.75rem 1rem;
	background: rgb(0, 51, 51);
	border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;
}

.me-show-info {
	flex: 1;
	min-width: 0;
}

.me-show-name {
	font-size: 0.95rem;
	font-weight: 600;
	color: #fff;
	line-height: 1.2;
}

.me-show-meta {
	font-size: 0.72rem;
	color: rgba(255, 255, 255, 0.65);
	margin-top: 0.1rem;
}

.me-show-logo img {
	max-height: 40px;
	max-width: 56px;
	border-radius: 4px;
	object-fit: contain;
}

/* ── Entry row select column ── */
.me-select-col {
	width: 48px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.3rem;
	padding-top: 0.15rem;
}

.me-sel-label {
	font-size: 0.6rem;
	font-weight: 700;
	letter-spacing: 0.07em;
	color: #6b7280;
	text-transform: uppercase;
	line-height: 1;
}

.me-sel-check {
	width: 1.5rem;
	height: 1.5rem;
	cursor: pointer;
	accent-color: rgb(0, 51, 51);
	border: 2px solid #94a3b8;
	border-radius: 4px;
	flex-shrink: 0;
}

/* ── Not-available indicator ── */
.me-not-avail {
	color: #dc3545;
	font-size: 1rem;
}

/* ── Small role icons inside entity-meta ── */
.me-entity-icon {
	font-size: 0.72rem;
	opacity: 0.6;
	margin-right: 0.2em;
}

/* ── Competition list ── */
.p-competition-list {
	font-size: 0.75rem;
	font-weight: 300;
	line-height: 1.2rem;
	margin-bottom: 0.25rem;
}

/* ── Misc ── */
.min-width-0 {
	min-width: 0;
}

.role-icon {
	font-size: 0.75rem;
}

@media only screen and (max-width: 375px) {
	:host ::ng-deep .popover {
		max-width: 100%;
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/components/my-entries/my-entries.component.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,cAAc;CACd,yBAAyB;CACzB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA,oEAAoE;AACpE;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;CACT,qBAAqB;CACrB,0BAA0B;CAC1B,4DAA4D;AAC7D;;AAEA;CACC,OAAO;CACP,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA,kCAAkC;AAClC;CACC,WAAW;CACX,cAAc;CACd,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,sBAAsB;CACtB,cAAc;CACd,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,cAAc;CACd,eAAe;CACf,4BAA4B;CAC5B,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;AACf;;AAEA,kCAAkC;AAClC;CACC,cAAc;CACd,eAAe;AAChB;;AAEA,8CAA8C;AAC9C;CACC,kBAAkB;CAClB,YAAY;CACZ,mBAAmB;AACpB;;AAEA,2BAA2B;AAC3B;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA,eAAe;AACf;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":[".me-page-title {\n\tdisplay: block;\n\tfont-size: 0.65rem;\n\tfont-weight: 700;\n\tletter-spacing: 0.1em;\n\tcolor: #111827;\n\ttext-transform: uppercase;\n\tmargin-bottom: 0.25rem;\n}\n\n.me-section-icon {\n\tfont-size: 0.65rem;\n\tcolor: #9ca3af;\n}\n\n/* ── Show card header (mirrors wf-show-header in the workflow) ── */\n.me-show-header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 1rem;\n\tpadding: 0.75rem 1rem;\n\tbackground: rgb(0, 51, 51);\n\tborder-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;\n}\n\n.me-show-info {\n\tflex: 1;\n\tmin-width: 0;\n}\n\n.me-show-name {\n\tfont-size: 0.95rem;\n\tfont-weight: 600;\n\tcolor: #fff;\n\tline-height: 1.2;\n}\n\n.me-show-meta {\n\tfont-size: 0.72rem;\n\tcolor: rgba(255, 255, 255, 0.65);\n\tmargin-top: 0.1rem;\n}\n\n.me-show-logo img {\n\tmax-height: 40px;\n\tmax-width: 56px;\n\tborder-radius: 4px;\n\tobject-fit: contain;\n}\n\n/* ── Entry row select column ── */\n.me-select-col {\n\twidth: 48px;\n\tflex-shrink: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 0.3rem;\n\tpadding-top: 0.15rem;\n}\n\n.me-sel-label {\n\tfont-size: 0.6rem;\n\tfont-weight: 700;\n\tletter-spacing: 0.07em;\n\tcolor: #6b7280;\n\ttext-transform: uppercase;\n\tline-height: 1;\n}\n\n.me-sel-check {\n\twidth: 1.5rem;\n\theight: 1.5rem;\n\tcursor: pointer;\n\taccent-color: rgb(0, 51, 51);\n\tborder: 2px solid #94a3b8;\n\tborder-radius: 4px;\n\tflex-shrink: 0;\n}\n\n/* ── Not-available indicator ── */\n.me-not-avail {\n\tcolor: #dc3545;\n\tfont-size: 1rem;\n}\n\n/* ── Small role icons inside entity-meta ── */\n.me-entity-icon {\n\tfont-size: 0.72rem;\n\topacity: 0.6;\n\tmargin-right: 0.2em;\n}\n\n/* ── Competition list ── */\n.p-competition-list {\n\tfont-size: 0.75rem;\n\tfont-weight: 300;\n\tline-height: 1.2rem;\n\tmargin-bottom: 0.25rem;\n}\n\n/* ── Misc ── */\n.min-width-0 {\n\tmin-width: 0;\n}\n\n.role-icon {\n\tfont-size: 0.75rem;\n}\n\n@media only screen and (max-width: 375px) {\n\t:host ::ng-deep .popover {\n\t\tmax-width: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
